import styled from 'styled-components';

const IconStyled = styled.svg`
  position: static;
  pointer-events: none;
  font-size: 0;
  transition: 135ms ease-in-out;
`;

export default IconStyled;
